import SettingsTabBase from "./SettingsTabBase.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";
import { isIAmOneOfBoardOwner, serverErrorMsg, showToast } from "../../../other/utils/utils.jsx";
import { exportBoardApi } from "../../../network/network.jsx";
import { shouldShowAsyncDialog } from "../AsyncTaskMessageEditor/SwivuAsyncMessagePopup.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";

export default class SettingsBoardPrefTab extends SettingsTabBase {
  static get $name() {
    return "SettingsBoardPrefTab";
  }

  // Factoryable type name
  static get type() {
    return "settingsboardpreftab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.boardPrefTab;
  }

  static get configurable() {
    return {
      title: "Board",
      cls: "p-[1em]",
      defaults: {
        labelWidth: "10em",
      },
      items: {
        nameField: {
          type: "text",
          name: "name",
          label: "Board Name",
          onChange: "up.onBoardNameChange",
        },
        boardOwnerField: {
          type: "combo",
          name: "boardOwner",
          label: "Board Owner",
          onChange: "up.onBoardOwnerChange",
          displayField: "name",
          valueField: "id",
        },
        ownerHtml: {
          cls: "ml-[10em]",
          html: `The Board Owner cannot be deleted. However, you can designate another Administrator as the Board Owner.`,
        },
        spacer1: {
          type: "widget",
        },
        boardExportButton: {
          type: "button",
          text: "Export Board",
          cls: "disabled:!text-[#3167a975] ml-[auto]",
          onClick: "up.onExportBoard",
        },
        shareScheduleInfo: {
          type: "widget",
          cls: "ml-[10em] text-[#3167a9] dark:text-[#6ba3ff]",
          html: `<i class="fa-regular fa-info-circle mr-1"></i> Share Schedule is now available in Settings → Schedule → Share Schedule`,
        }
      }
    };
  }

  loadRecord(record, context) {
    super.loadRecord(record, context);
    this.context = context;
    this.project = context.project;
    const { selectedBoard } = context;
    const { nameField, boardOwnerField, boardExportButton } = this.widgetMap;

    nameField.value = selectedBoard.name;
    boardOwnerField.items = this.project.boardUsersStore.query((boardUser) => boardUser.userId && boardUser.roles === GRANTS.grant_one, true);

    const boardStore = this.context.boardManager.boardNameStore.getById(this.context.boardManager.selectedBoard.id);
    boardOwnerField.value = boardStore.owner;
    boardOwnerField.disabled = !isIAmOneOfBoardOwner(this.project, boardStore.owner) || this.context.user.isDemoUser;
    boardExportButton.disabled = (this.context.user.isDemoUser || !this.context.user.can(GRANTS.grant_one));
  }

  onBoardOwnerChange({ source, userAction, value }) {
    if (userAction) {
      const selectedBoard = this.context.selectedBoard;
      if (selectedBoard) {
        selectedBoard.record.owner = value;
        source.value = value;
        source.disabled = !isIAmOneOfBoardOwner(this.project, value);
      }
    }
  }

  onBoardNameChange({ value }) {
    const selectedBoard = this.context.selectedBoard;
    if (selectedBoard) {
      selectedBoard.record.name = value;
    }
  }


  onExportBoard() {
    const { selectedBoard, editorHandler } = this.context;
    this.mask("Exporting Board...");
    exportBoardApi(selectedBoard.id).then(() => {
      // Removed success toast
    }).catch(() => {
      showToast({
        msg: serverErrorMsg(),
        type: "error"
      })
    }).finally(() => {
      this.unmask();
    });
    const showDialog = shouldShowAsyncDialog('BOARD_EXPORT');
    showDialog &&  editorHandler.openEditor(EDITOR_KEYS.asyncTaskMessageEditor, null, {record: "BOARD_EXPORT"}, { useExisting: true, by: "recordType" });
  }

  swivuCheckGrants(user) {
    if (user.isDemoUser || !user.can(GRANTS.grant_one)) {
      const { nameField, boardOwnerField, boardExportButton } = this.widgetMap;
      nameField.disabled = true;
      boardOwnerField.disabled = true;
      boardExportButton.disabled = true;
    }
  }
}

SettingsBoardPrefTab.initClass();
